(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.ReactPlandalf = {}, global.React));
})(this, (function (exports, React) { 'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }
  function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }
  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [null];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
  }
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
  }
  function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e && _setPrototypeOf(t, e);
  }
  function _isNativeFunction(t) {
    try {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
      return "function" == typeof t;
    }
  }
  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function () {
      return !!t;
    })();
  }
  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;
      try {
        if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = !0, n = r;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
  }
  function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
  }
  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (String )(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
  }
  function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function (t) {
      if (null === t || !_isNativeFunction(t)) return t;
      if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== r) {
        if (r.has(t)) return r.get(t);
        r.set(t, Wrapper);
      }
      function Wrapper() {
        return _construct(t, arguments, _getPrototypeOf(this).constructor);
      }
      return Wrapper.prototype = Object.create(t.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
  }

  var CDN_DOMAIN = "https://js.plandalf.com";
  var SDK_PATH = "/v1.js";
  var V1_URL = "".concat(CDN_DOMAIN).concat(SDK_PATH);
  // const V1_URL_REGEX = new RegExp(`${V1_URL.replace(/\/$/, '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\/?(\?.*)?$`);
  var EXISTING_SCRIPT_MESSAGE = "loadPlandalf.setLoadParameters was called but an existing Plandalf.js script already exists in the document; existing script parameters will be used";
  var findScript = function findScript() {
    var scripts = document.querySelectorAll('script');
    var plandalfScriptRegex = /^https:\/\/js\.plandalf\.[^/]+\/v1\.js(\?.*)?$/;
    for (var _i = 0, _Array$from = Array.from(scripts); _i < _Array$from.length; _i++) {
      var script = _Array$from[_i];
      if (plandalfScriptRegex.test(script.src)) {
        return script;
      }
    }
    return null;
  };
  var injectScript = function injectScript(options) {
    var script = document.createElement("script");
    if (options !== null && options !== void 0 && options.sdkUrl) {
      script.src = options.sdkUrl;
    } else {
      script.src = "".concat(V1_URL);
    }
    var headOrBody = document.head || document.body;
    if (!headOrBody) {
      throw new Error("Expected document.body not to be null. Plandalf.js requires a <body> element.");
    }
    headOrBody.appendChild(script);
    return script;
  };
  var registerWrapper = function registerWrapper(plandalf, startTime) {
    if (!plandalf || !plandalf._registerWrapper) {
      return;
    }
    plandalf._registerWrapper({
      name: "plandalf-js",
      version: "0.1.14",
      startTime: startTime
    });
  };
  var plandalfPromise$1 = null;
  var onErrorListener = null;
  var onLoadListener = null;
  var onError = function onError(reject) {
    return function () {
      reject(new Error("Failed to load Plandalf.js"));
    };
  };
  var onLoad = function onLoad(resolve, reject) {
    return function () {
      if (window.Plandalf) {
        resolve(window.Plandalf);
      } else {
        reject(new Error("Plandalf.js not available"));
      }
    };
  };
  var loadScript = function loadScript(options) {
    // Ensure that we only attempt to load Plandalf.js at most once
    if (plandalfPromise$1 !== null) {
      return plandalfPromise$1;
    }
    plandalfPromise$1 = new Promise(function (resolve, reject) {
      if (typeof window === "undefined" || typeof document === "undefined") {
        // Resolve to null when imported server side. This makes the module
        // safe to import in an isomorphic code base.
        resolve(null);
        return;
      }
      if (window.Plandalf) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
        resolve(window.Plandalf);
        return;
      }
      try {
        var script = findScript();
        if (script && options) {
          console.warn(EXISTING_SCRIPT_MESSAGE);
        } else if (!script) {
          script = injectScript(options);
        } else if (script && onLoadListener !== null && onErrorListener !== null) {
          var _script$parentNode;
          // remove event listeners
          script.removeEventListener("load", onLoadListener);
          script.removeEventListener("error", onErrorListener);
          // if script exists, but we are reloading due to an error,
          // reload script to trigger 'load' event
          (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
          script = injectScript(options);
        }
        onLoadListener = onLoad(resolve, reject);
        onErrorListener = onError(reject);
        script.addEventListener("load", onLoadListener);
        script.addEventListener("error", onErrorListener);
      } catch (error) {
        reject(error);
        return;
      }
    });
    // Resets plandalfPromise on error
    return plandalfPromise$1["catch"](function (error) {
      plandalfPromise$1 = null;
      return Promise.reject(error);
    });
  };
  var initPlandalf = function initPlandalf(maybePlandalf, args, startTime) {
    if (maybePlandalf === null) {
      return null;
    }
    var plandalf = maybePlandalf.apply(undefined, args);
    registerWrapper(plandalf, startTime);
    return plandalf;
  };
  var plandalfPromise;
  var loadCalled = false;
  var getPlandalfPromise = function getPlandalfPromise(params) {
    if (plandalfPromise) {
      return plandalfPromise;
    }
    // Assuming loadPlandalf returns a Promise<PlandalfConstructor | null>, not Promise<PlandalfConstructor | Plandalf>
    plandalfPromise = loadScript(params || null) // Assuming this should be loadScript, not loadPlandalf, based on your context
    ["catch"](function (error) {
      // clear cache on error
      plandalfPromise = null;
      return Promise.reject(error);
    });
    return plandalfPromise;
  };
  // Execute our own script injection after a tick to give users time to do their
  // own script injection.
  Promise.resolve().then(function () {
    return getPlandalfPromise();
  })["catch"](function (error) {
    if (!loadCalled) {
      console.warn(error);
    }
  });
  var loadPlandalf = function loadPlandalf() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    loadCalled = true;
    var startTime = Date.now();
    // Ensure initPlandalf returns PlandalfConstructor or null, not Plandalf
    return getPlandalfPromise(args[1]).then(function (maybePlandalfConstructor) {
      // The initPlandalf function needs to return a type that matches PlandalfConstructor or null
      // Adjust the initPlandalf function's implementation to ensure it returns the correct type
      if (maybePlandalfConstructor === null) {
        return null; // Ensure we return null directly if maybePlandalfConstructor is null
      } else {
        return initPlandalf(maybePlandalfConstructor, args, startTime); // Ensure this returns PlandalfConstructor
      }
    });
  };

  var PlandalfContext = /*#__PURE__*/React.createContext({
    plandalf: undefined,
    state: 'loading'
  });
  PlandalfContext.displayName = 'PlandalfContext';
  var PlandalfError = /*#__PURE__*/function (_Error) {
    function PlandalfError(message) {
      var _this;
      _classCallCheck(this, PlandalfError);
      _this = _callSuper(this, PlandalfError, [message]);
      _this.name = 'PlandalfError';
      return _this;
    }
    _inherits(PlandalfError, _Error);
    return _createClass(PlandalfError);
  }(/*#__PURE__*/_wrapNativeSuper(Error));
  function isSdkError(error) {
    return error instanceof PlandalfError;
  }
  function logErrorToService(error, errorInfo) {
    console.log('logging an error!');
  }
  var SDKErrorBoundary = /*#__PURE__*/function (_React$Component) {
    function SDKErrorBoundary() {
      var _this2;
      _classCallCheck(this, SDKErrorBoundary);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2 = _callSuper(this, SDKErrorBoundary, [].concat(args));
      _defineProperty(_this2, "state", {
        hasError: false,
        error: null
      });
      return _this2;
    }
    _inherits(SDKErrorBoundary, _React$Component);
    return _createClass(SDKErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, errorInfo) {
        if (isSdkError(error)) {
          // Log SDK errors or handle them as needed
          logErrorToService();
        } else {
          // If it's not an SDK error, rethrow it
          throw error;
        }
      }
    }, {
      key: "render",
      value: function render() {
        // Always render children, ignore SDK issues
        return this.props.children;
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError(error) {
        // You can determine if the error is from your SDK
        if (isSdkError(error)) {
          return {
            hasError: true,
            error: error
          };
        }
        // If it's not an SDK error, we won't handle it here
        return null;
      }
    }]);
  }(React.Component);
  var usePlandalf = function usePlandalf() {
    return React.useContext(PlandalfContext);
  };
  var PlandalfProvider = function PlandalfProvider(_ref) {
    var children = _ref.children,
      client = _ref.client,
      agent = _ref.agent,
      plandalf = _ref.plandalf,
      apiUrl = _ref.apiUrl,
      sdkUrl = _ref.sdkUrl;
    var _React$useState = React.useState({
        plandalf: undefined,
        state: 'loading'
      }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      ctx = _React$useState2[0],
      setContext = _React$useState2[1];
    React.useEffect(function () {
      if (plandalf) {
        // if plandalf already exists on window
        setContext({
          plandalf: plandalf,
          state: 'loaded'
        });
      } else {
        // Load the script
        loadPlandalf(agent, {
          clientId: client,
          apiUrl: apiUrl,
          sdkUrl: sdkUrl
        }).then(function (p) {
          if (p) {
            setContext({
              plandalf: p,
              state: 'loaded'
            });
          } else {
            setContext({
              plandalf: undefined,
              state: 'error'
            });
          }
        });
      }
    }, [agent]);
    return /*#__PURE__*/React.createElement(SDKErrorBoundary, null, /*#__PURE__*/React.createElement(PlandalfContext.Provider, {
      value: ctx
    }, children));
  };
  var Gate = function Gate(_ref2) {
    var children = _ref2.children,
      name = _ref2.name,
      onUnlock = _ref2.onUnlock;
    var _usePlandalf = usePlandalf(),
      plandalf = _usePlandalf.plandalf;
    var element = plandalf === null || plandalf === void 0 ? void 0 : plandalf.element(name);
    var hasAccess = !(element !== null && element !== void 0 && element.active());
    var callElementUnlock = function callElementUnlock() {
      return (element === null || element === void 0 ? void 0 : element.call('unlock')) || Promise.reject(new Error('Element not found'));
    };
    var handleUnlock = function handleUnlock() {
      return new Promise(function (resolve, reject) {
        callElementUnlock().then(function (res) {
          if (res.success) {
            onUnlock && onUnlock(res);
            resolve(res);
          }
        })["catch"](function (err) {
          reject((err === null || err === void 0 ? void 0 : err.message) || err);
        });
      });
    };
    if (typeof children === 'function') {
      return children(hasAccess, handleUnlock);
    }
    if (hasAccess) {
      return children;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4",
      role: "alert"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold"
    }, "No access to this feature"), /*#__PURE__*/React.createElement("button", {
      onClick: handleUnlock
    }, "Upgrade now"));
  };

  exports.Gate = Gate;
  exports.PlandalfContext = PlandalfContext;
  exports.PlandalfProvider = PlandalfProvider;
  exports.usePlandalf = usePlandalf;

}));
